export const jobs = [
  {
    title: "Software Engineer",
    job_id: "JOB001",
    location: "Remote / San Francisco, CA",
    client: "Marks Group",
    details: {
      counts: 2,
      job_level: "Mid-Level/Senior",
      status: "Closed",
      salary: "$90,000 – $130,000 per year",
      job_description: [
        "Develop and maintain web applications",
        "Collaborate with cross-functional teams",
        "Ensure code quality and best practices"
      ],
      key_responsibilities: [
        "Write clean, scalable code",
        "Perform code reviews",
        "Fix bugs and optimize performance"
      ],
      preferred_qualifications: [
        "Proficiency in JavaScript, React, Node.js",
        "Experience with Git and Agile workflows",
        "Problem-solving skills"
      ]
    }
  },
  {
    title: "Graphic Designer",
    job_id: "JOB002",
    location: "New York, NY",
    client: "Schiller-Fadel",
    details: {
      counts: 1,
      job_level: "Entry-Level",
      status: "Draft",
      salary: "$50,000 – $70,000 per year",
      job_description: [
        "Create visual concepts for branding and marketing",
        "Design social media and digital assets",
        "Collaborate with marketing and content teams"
      ],
      key_responsibilities: [
        "Develop creative designs",
        "Incorporate feedback into designs",
        "Maintain brand consistency"
      ],
      preferred_qualifications: [
        "Skilled in Adobe Creative Suite",
        "Strong typography and layout skills",
        "Portfolio showcasing previous work"
      ]
    }
  },
  {
    title: "Data Analyst",
    job_id: "JOB003",
    location: "Chicago, IL",
    client: "Harris, Lowe and Satterfield",
    details: {
      counts: 1,
      job_level: "Assiocate/Professional",
      status: "Active",
      salary: "$60,000 – $85,000 per year",
      job_description: [
        "Analyze data to drive business decisions",
        "Create dashboards and reports",
        "Provide actionable insights"
      ],
      key_responsibilities: [
        "Data cleaning and validation",
        "Prepare regular reports",
        "Collaborate with teams to identify trends"
      ],
      preferred_qualifications: [
        "Strong Excel and SQL skills",
        "Experience with Tableau or Power BI",
        "Attention to detail and analytical mindset"
      ]
    }
  },
  {
    title: "Marketing Manager",
    job_id: "JOB004",
    location: "Los Angeles, CA",
    client: "Mayer, Kertzmann and Cole",
    details: {
      counts: 1,
      job_level: "Manager",
      status: "Active",
      salary: "$75,000 – $110,000 per year",
      job_description: [
        "Plan, execute, and optimize marketing campaigns",
        "Drive brand awareness and lead generation",
        "Manage marketing budget and resources"
      ],
      key_responsibilities: [
        "Lead the marketing team",
        "Oversee digital marketing strategies",
        "Analyze campaign performance"
      ],
      preferred_qualifications: [
        "Experience in digital marketing",
        "SEO/SEM knowledge",
        "Content creation and leadership skills"
      ]
    }
  }
];
